(function($) {
    $.fn.setUpContextMenu = function() {
    	var menu = $(this);
        menu.dialog({
            autoOpen: false,
            resizable: false,
            width: 'auto',
            height: 'auto',
            minHeight: 'auto',
            minWidth: 'auto',
            dialogClass: 'context-dialog-wrapper'
        })
        
        $("html").click(function(e){
    		var clicked = $(e.target);
        	if(e.target.nodeName.toLowerCase() == "a" || !(clicked.is(menu) || clicked.parents("#" + menu.attr("id")).length))
    		{
        		if(menu.is(":visible"))
        		{
        			menu.closeContextMenu();
        		}
    		}
        });
        
        return $(this);
    };

    $.fn.openContextMenu = function(jsEvent) {
        var menu = $(this);
        menu.css('padding', 0);
        menu.dialog('option', 'position', [jsEvent.clientX, jsEvent.clientY]);
        menu.unbind('dialogopen');
        menu.bind('dialogopen', function(jsEvent, ui) {
        	menu.siblings('.ui-dialog-titlebar').hide();
        	menu.find("a").blur();
        });
        menu.dialog({position: { my: "center", at: "center", of: jsEvent}});
        menu.dialog('open');

        return menu;
    };
    
    $.fn.closeContextMenu = function(jsEvent) {
    	var menu = $(this);
    	menu.find("li.col_list").hide();
    	menu.dialog("close");
    }
    
})(jQuery);